export var DynamoDBRestoreToS3OutputFormat;
(function (DynamoDBRestoreToS3OutputFormat) {
    DynamoDBRestoreToS3OutputFormat["DYNAMODB_RESTORE_TO_S3_OUTPUT_FORMAT_UNSPECIFIED"] = "DYNAMODB_RESTORE_TO_S3_OUTPUT_FORMAT_UNSPECIFIED";
    DynamoDBRestoreToS3OutputFormat["DYNAMODB_RESTORE_TO_S3_OUTPUT_FORMAT_DYNAMODB_JSON"] = "DYNAMODB_JSON";
})(DynamoDBRestoreToS3OutputFormat || (DynamoDBRestoreToS3OutputFormat = {}));
